export const permissionsTranslations = {
  en: {
    permissions: {
      // Dashboard
      dashboard: {
        view: {
          name: "View Dashboard",
          description: "Access to view the main dashboard and analytics"
        },
        filter_by_user: {
          name: "Filter Dashboard by User",
          description: "Ability to filter dashboard data by specific users"
        }
      },
      // Dashboard IBE
      dashboard_ibe: {
        view: {
          name: "View IBE Dashboard",
          description: "Access to view the IBE dashboard"
        }
      },
      // Clients
      clients: {
        view: {
          name: "View Clients",
          description: "View client data and their history"
        },
        create: {
          name: "Create Clients",
          description: "Add new clients to the system"
        },
        update: {
          name: "Update Clients",
          description: "Modify existing client data"
        },
        delete: {
          name: "Delete Clients",
          description: "Remove clients from the system (critical operation)"
        },
        filter_by_user: {
          name: "Filter Clients by User",
          description: "Filter clients by assigned user"
        }
      },
      // Deals
      deals: {
        view: {
          name: "View Deals",
          description: "View all contracts and sales opportunities"
        },
        create: {
          name: "Create Deals",
          description: "Create new contracts and opportunities"
        },
        update: {
          name: "Update Deals",
          description: "Modify existing contracts"
        },
        delete: {
          name: "Delete Deals",
          description: "Delete contracts (warning: may affect commissions)"
        },
        filter_by_user: {
          name: "Filter Deals by User",
          description: "Filter deals by assigned user"
        },
        generate: {
          name: "Generate Deal PDFs",
          description: "Generate PDF documents for deals"
        },
        hours_view: {
          name: "View Hours Package",
          description: "View hours package information on deals"
        },
        hours_update: {
          name: "Update Hours Package",
          description: "Modify hours package settings on deals"
        }
      },
      // Leads
      leads: {
        view: {
          name: "View Leads",
          description: "View all leads and opportunities"
        },
        create: {
          name: "Create Leads",
          description: "Create new leads"
        },
        update: {
          name: "Update Leads",
          description: "Modify existing leads"
        },
        delete: {
          name: "Delete Leads",
          description: "Delete leads from the system"
        },
        convert: {
          name: "Convert Leads",
          description: "Convert leads to clients or deals"
        },
        filter_by_user: {
          name: "Filter Leads by User",
          description: "Filter leads by assigned user"
        }
      },
      // Lead Notes
      lead_notes: {
        view: {
          name: "View Lead Notes",
          description: "View notes on leads"
        },
        create: {
          name: "Create Lead Notes",
          description: "Create notes on leads"
        },
        update: {
          name: "Update Lead Notes",
          description: "Modify existing lead notes"
        },
        delete: {
          name: "Delete Lead Notes",
          description: "Delete lead notes"
        }
      },
      // Lead Sources
      lead_sources: {
        view: {
          name: "View Lead Sources",
          description: "View lead acquisition sources"
        },
        create: {
          name: "Create Lead Sources",
          description: "Create new lead sources"
        },
        update: {
          name: "Update Lead Sources",
          description: "Modify existing lead sources"
        },
        delete: {
          name: "Delete Lead Sources",
          description: "Delete lead sources"
        },
        manage: {
          name: "Manage Lead Sources",
          description: "Full management of lead sources"
        }
      },
      // Calendar
      calendar: {
        view: {
          name: "View Calendar",
          description: "Access to view calendar events"
        },
        create: {
          name: "Create Events",
          description: "Create new calendar events"
        },
        update: {
          name: "Update Events",
          description: "Modify existing calendar events"
        },
        delete: {
          name: "Delete Events",
          description: "Delete calendar events"
        }
      },
      // Projects
      projects: {
        view: {
          name: "View Projects",
          description: "View project information and progress"
        },
        create: {
          name: "Create Projects",
          description: "Create new projects"
        },
        update: {
          name: "Update Projects",
          description: "Modify existing projects"
        },
        delete: {
          name: "Delete Projects",
          description: "Delete projects from the system"
        }
      },
      // Tasks
      tasks: {
        view: {
          name: "View Tasks",
          description: "View tasks and activities"
        },
        create: {
          name: "Create Tasks",
          description: "Create new tasks"
        },
        update: {
          name: "Update Tasks",
          description: "Modify existing tasks"
        },
        delete: {
          name: "Delete Tasks",
          description: "Delete tasks"
        },
        complete: {
          name: "Complete Tasks",
          description: "Mark tasks as completed"
        },
        assign: {
          name: "Assign Tasks",
          description: "Assign tasks to users"
        },
        filter_by_user: {
          name: "Filter Tasks by User",
          description: "Filter tasks by assigned user"
        }
      },
      // Tickets
      tickets: {
        view: {
          name: "View Tickets",
          description: "View support tickets"
        },
        create: {
          name: "Create Tickets",
          description: "Create new support tickets"
        },
        update: {
          name: "Update Tickets",
          description: "Modify existing tickets"
        },
        delete: {
          name: "Delete Tickets",
          description: "Delete tickets"
        },
        assign: {
          name: "Assign Tickets",
          description: "Assign tickets to users"
        },
        generate: {
          name: "Export Tickets",
          description: "Export tickets data to CSV/Excel"
        }
      },
      // Ticket Types (Intervention Types)
      ticket_types: {
        view: {
          name: "View Ticket Types",
          description: "View intervention type configurations"
        },
        create: {
          name: "Create Ticket Types",
          description: "Create new intervention types"
        },
        update: {
          name: "Update Ticket Types",
          description: "Modify existing intervention types"
        },
        delete: {
          name: "Delete Ticket Types",
          description: "Remove intervention types"
        },
        manage: {
          name: "Manage Ticket Types",
          description: "Full management of intervention types"
        }
      },
      // Ticket Time Entries (Time Tracking)
      ticket_time_entries: {
        view: {
          name: "View Time Entries",
          description: "View time tracking entries on tickets"
        },
        create: {
          name: "Create Time Entries",
          description: "Log time on tickets"
        },
        update: {
          name: "Update Time Entries",
          description: "Modify existing time entries"
        },
        delete: {
          name: "Delete Time Entries",
          description: "Remove time entries"
        },
        manage: {
          name: "Manage Time Entries",
          description: "Full management of all time entries"
        }
      },
      // Ticket SLA Configs
      ticket_sla_configs: {
        view: {
          name: "View SLA Configurations",
          description: "View SLA configuration settings"
        },
        create: {
          name: "Create SLA Configurations",
          description: "Create new SLA configurations"
        },
        update: {
          name: "Update SLA Configurations",
          description: "Modify existing SLA configurations"
        },
        delete: {
          name: "Delete SLA Configurations",
          description: "Remove SLA configurations"
        },
        manage: {
          name: "Manage SLA Configurations",
          description: "Full management of SLA settings"
        }
      },
      // WhatsApp
      whatsapp: {
        view: {
          name: "View WhatsApp",
          description: "Access WhatsApp conversations"
        },
        create: {
          name: "Send WhatsApp Messages",
          description: "Send messages via WhatsApp to clients"
        },
        assign: {
          name: "View Only Assigned WhatsApp Chats",
          description: "Only see WhatsApp chats from assigned clients"
        },
        update: {
          name: "Manage WhatsApp Configurations",
          description: "Assign WhatsApp configurations to users and manage settings"
        }
      },
      // Invoices
      invoices: {
        view: {
          name: "View Invoices",
          description: "Access invoice information"
        },
        create: {
          name: "Create Invoices",
          description: "Generate new invoices"
        },
        update: {
          name: "Update Invoices",
          description: "Modify existing invoices"
        },
        delete: {
          name: "Delete Invoices",
          description: "Delete invoices from the system"
        }
      },
      // FattureInCloud
      fattureincloud: {
        view: {
          name: "View Fatture in Cloud Data",
          description: "Access Fatture in Cloud integration data"
        },
        create: {
          name: "Create Fatture in Cloud Invoices",
          description: "Create invoices through Fatture in Cloud"
        },
        update: {
          name: "Update Fatture in Cloud Settings",
          description: "Modify Fatture in Cloud configuration"
        },
        delete: {
          name: "Delete Fatture in Cloud Data",
          description: "Remove data from Fatture in Cloud integration"
        },
        sync: {
          name: "Sync Fatture in Cloud",
          description: "Synchronize data with Fatture in Cloud"
        },
        configure: {
          name: "Configure Fatture in Cloud",
          description: "Configure Fatture in Cloud integration settings"
        }
      },
      // Documents
      documents: {
        view: {
          name: "View Documents",
          description: "Access document library"
        },
        create: {
          name: "Upload Documents",
          description: "Upload new documents to the system"
        },
        update: {
          name: "Update Documents",
          description: "Modify existing documents"
        },
        delete: {
          name: "Delete Documents",
          description: "Remove documents from the system"
        },
        manage: {
          name: "Manage Documents",
          description: "Full document management access"
        },
        filter_by_user: {
          name: "Filter Documents by User",
          description: "Filter documents by owner"
        }
      },
      // Settings
      settings: {
        view: {
          name: "View Settings",
          description: "Access system settings"
        },
        update: {
          name: "Update Settings",
          description: "Modify system configuration"
        },
        create: {
          name: "Import/Export Data",
          description: "Import and export system data"
        }
      },
      // Users
      users: {
        view: {
          name: "View Users",
          description: "Access user information"
        },
        create: {
          name: "Create Users",
          description: "Add new users to the system"
        },
        update: {
          name: "Update Users",
          description: "Modify existing user data"
        },
        delete: {
          name: "Delete Users",
          description: "Remove users from the system"
        }
      },
      // Roles
      roles: {
        view: {
          name: "View Roles",
          description: "Access role configuration"
        },
        create: {
          name: "Create Roles",
          description: "Create new user roles"
        },
        update: {
          name: "Update Roles",
          description: "Modify existing roles"
        },
        delete: {
          name: "Delete Roles",
          description: "Remove roles from the system"
        }
      },
      // Services
      services: {
        view: {
          name: "View Services",
          description: "Access service catalog"
        },
        create: {
          name: "Create Services",
          description: "Add new services"
        },
        update: {
          name: "Update Services",
          description: "Modify existing services"
        },
        delete: {
          name: "Delete Services",
          description: "Remove services"
        },
        manage: {
          name: "Manage Services",
          description: "Full service management access"
        }
      },
      // Service Costs
      service_costs: {
        view: {
          name: "View Service Costs",
          description: "View service cost information"
        },
        create: {
          name: "Create Service Costs",
          description: "Add new service costs"
        },
        update: {
          name: "Update Service Costs",
          description: "Modify existing service costs"
        },
        delete: {
          name: "Delete Service Costs",
          description: "Remove service costs"
        }
      },
      // Service Task Templates
      service_task_templates: {
        view: {
          name: "View Service Task Templates",
          description: "View service task templates"
        },
        create: {
          name: "Create Service Task Templates",
          description: "Create new service task templates"
        },
        update: {
          name: "Update Service Task Templates",
          description: "Modify existing service task templates"
        },
        delete: {
          name: "Delete Service Task Templates",
          description: "Remove service task templates"
        },
        manage: {
          name: "Manage Service Task Templates",
          description: "Full management of service task templates"
        }
      },
      // Service Margins
      service_margins: {
        view: {
          name: "View Service Margins",
          description: "View service margin information"
        }
      },
      // Client Expenses
      client_expenses: {
        view: {
          name: "View Client Expenses",
          description: "View client expense information"
        },
        create: {
          name: "Create Client Expenses",
          description: "Add new client expenses"
        },
        update: {
          name: "Update Client Expenses",
          description: "Modify existing client expenses"
        },
        delete: {
          name: "Delete Client Expenses",
          description: "Remove client expenses"
        },
        filter_by_user: {
          name: "Filter Client Expenses by User",
          description: "Filter client expenses by user"
        }
      },
      // Rentals
      rentals: {
        view: {
          name: "View Rentals",
          description: "View rental information"
        },
        create: {
          name: "Create Rentals",
          description: "Create new rentals"
        },
        update: {
          name: "Update Rentals",
          description: "Modify existing rentals"
        },
        delete: {
          name: "Delete Rentals",
          description: "Remove rentals"
        }
      },
      // Payment Methods
      payment_methods: {
        view: {
          name: "View Payment Methods",
          description: "Access payment method settings"
        },
        create: {
          name: "Create Payment Methods",
          description: "Add new payment methods"
        },
        update: {
          name: "Update Payment Methods",
          description: "Modify payment methods"
        },
        delete: {
          name: "Delete Payment Methods",
          description: "Remove payment methods"
        }
      },
      // API Configuration
      api_config: {
        view: {
          name: "View API Configurations",
          description: "Access API settings"
        },
        create: {
          name: "Create API Configurations",
          description: "Add new API configurations"
        },
        update: {
          name: "Update API Configurations",
          description: "Modify API settings"
        },
        delete: {
          name: "Delete API Configurations",
          description: "Remove API configurations"
        }
      },
      // Categories
      categories: {
        view: {
          name: "View Categories",
          description: "Access category management"
        },
        create: {
          name: "Create Categories",
          description: "Add new categories"
        },
        update: {
          name: "Update Categories",
          description: "Modify existing categories"
        },
        delete: {
          name: "Delete Categories",
          description: "Remove categories"
        }
      },
      // Inventory
      inventory: {
        view: {
          name: "View Inventory",
          description: "Access inventory information"
        },
        create: {
          name: "Create Inventory",
          description: "Add new inventory items"
        },
        update: {
          name: "Update Inventory",
          description: "Modify inventory items"
        },
        delete: {
          name: "Delete Inventory",
          description: "Remove inventory items"
        },
        manage: {
          name: "Manage Inventory",
          description: "Full inventory management access"
        }
      },
      // Commissions
      commissions: {
        view: {
          name: "View Commissions",
          description: "Access commission information"
        },
        update: {
          name: "Update Commissions",
          description: "Modify commission data"
        },
        manage: {
          name: "Manage Commissions",
          description: "Full commission management (financial operation)"
        },
        refresh: {
          name: "Refresh Commissions",
          description: "Recalculate commission data"
        }
      },
      // User Commissions
      user_commissions: {
        view: {
          name: "View User Commissions",
          description: "View user commission information"
        },
        update: {
          name: "Update User Commissions",
          description: "Modify user commission data (critical financial operation)"
        },
        manage: {
          name: "Manage User Commissions",
          description: "Full user commission management"
        }
      },
      // Commission Groups
      commission_groups: {
        view: {
          name: "View Commission Groups",
          description: "View commission group information"
        },
        create: {
          name: "Create Commission Groups",
          description: "Create new commission groups"
        },
        update: {
          name: "Update Commission Groups",
          description: "Modify existing commission groups"
        },
        delete: {
          name: "Delete Commission Groups",
          description: "Remove commission groups"
        }
      },
      // Commission Reports
      commission_reports: {
        view: {
          name: "View Commission Reports",
          description: "View commission reports and analytics"
        }
      },
      // Commission Advanced
      commission_advanced: {
        manage: {
          name: "Manage Advanced Commissions",
          description: "Access advanced commission settings"
        }
      },
      // External Partners
      external_partners: {
        view: {
          name: "View External Partners",
          description: "View external partner information"
        },
        create: {
          name: "Create External Partners",
          description: "Add new external partners"
        },
        update: {
          name: "Update External Partners",
          description: "Modify existing external partners"
        },
        delete: {
          name: "Delete External Partners",
          description: "Remove external partners"
        }
      },
      // Partner Tasks
      partner_tasks: {
        view: {
          name: "View Partner Tasks",
          description: "View partner task information"
        },
        create: {
          name: "Create Partner Tasks",
          description: "Create new partner tasks"
        },
        update: {
          name: "Update Partner Tasks",
          description: "Modify existing partner tasks"
        },
        delete: {
          name: "Delete Partner Tasks",
          description: "Remove partner tasks"
        },
        assign: {
          name: "Assign Partner Tasks",
          description: "Assign tasks to partners"
        },
        manage: {
          name: "Manage Partner Tasks",
          description: "Full partner task management"
        }
      },
      // Referrers
      referrers: {
        view: {
          name: "View Referrers",
          description: "View referrer information"
        },
        create: {
          name: "Create Referrers",
          description: "Add new referrers"
        },
        update: {
          name: "Update Referrers",
          description: "Modify existing referrers"
        },
        delete: {
          name: "Delete Referrers",
          description: "Remove referrers"
        }
      },
      // Analytics
      analytics: {
        view: {
          name: "View Analytics",
          description: "Access analytics and business intelligence"
        },
        refresh: {
          name: "Refresh Analytics",
          description: "Refresh analytics data"
        }
      },
      // Reports
      reports: {
        view: {
          name: "View Reports",
          description: "Access system reports"
        },
        create: {
          name: "Create Reports",
          description: "Generate new reports"
        },
        update: {
          name: "Update Reports",
          description: "Modify existing reports"
        },
        delete: {
          name: "Delete Reports",
          description: "Remove reports"
        },
        export: {
          name: "Export Reports",
          description: "Export report data"
        }
      },
      // Templates
      templates: {
        view: {
          name: "View Templates",
          description: "Access document templates"
        },
        create: {
          name: "Create Templates",
          description: "Create new document templates"
        },
        update: {
          name: "Update Templates",
          description: "Modify existing templates"
        },
        delete: {
          name: "Delete Templates",
          description: "Remove document templates"
        }
      },
      // Signatures
      signatures: {
        view: {
          name: "View Signatures",
          description: "Access document signatures"
        },
        create: {
          name: "Create Signatures",
          description: "Create new signatures for documents"
        }
      },
      // Email Signature
      email_signature: {
        generate: {
          name: "Generate Email Signature",
          description: "Generate personalized email signatures"
        }
      },
      // Newsletter
      newsletter: {
        view: {
          name: "View Newsletter",
          description: "Access newsletter management system"
        },
        create: {
          name: "Create Newsletter",
          description: "Create new newsletter lists and campaigns"
        },
        update: {
          name: "Update Newsletter",
          description: "Modify existing newsletter lists and campaigns"
        },
        delete: {
          name: "Delete Newsletter",
          description: "Remove newsletter lists and campaigns"
        },
        send: {
          name: "Send Newsletter",
          description: "Send newsletter campaigns to subscribers"
        }
      },
      // Bookings
      booking: {
        view: {
          name: "View Bookings",
          description: "View bookings and their details"
        },
        create: {
          name: "Create Bookings",
          description: "Create new bookings"
        },
        update: {
          name: "Update Bookings",
          description: "Modify existing bookings (confirm, reschedule, etc.)"
        },
        delete: {
          name: "Delete Bookings",
          description: "Cancel or delete bookings"
        },
        manage: {
          name: "Manage Bookings",
          description: "Full booking management (event types, availability)"
        },
        filter_by_user: {
          name: "Filter Bookings by User",
          description: "Only see bookings assigned to the current user"
        }
      },
      // Booking Settings
      settings_booking: {
        view: {
          name: "View Booking Settings",
          description: "View booking configuration"
        },
        manage: {
          name: "Manage Booking Settings",
          description: "Modify booking settings (branding, notifications, etc.)"
        }
      },
      // SendGrid Settings
      settings_sendgrid: {
        view: {
          name: "View SendGrid Domains",
          description: "View SendGrid domain configuration"
        },
        create: {
          name: "Create SendGrid Domains",
          description: "Add new SendGrid domains"
        },
        update: {
          name: "Update SendGrid Domains",
          description: "Modify SendGrid domain settings"
        },
        delete: {
          name: "Delete SendGrid Domains",
          description: "Remove SendGrid domains"
        },
        verify: {
          name: "Verify SendGrid Domains",
          description: "Verify SendGrid domains via DNS"
        }
      },
      // Custom Fields
      custom_fields: {
        manage: {
          name: "Manage Custom Fields",
          description: "Create and manage custom fields"
        }
      },
      // Custom Queries
      custom_queries: {
        view: {
          name: "View Custom Queries",
          description: "View custom database queries"
        },
        create: {
          name: "Create Custom Queries",
          description: "Create new custom queries"
        }
      }
    }
  },
  it: {
    permissions: {
      // Dashboard
      dashboard: {
        view: {
          name: "Visualizza Dashboard",
          description: "Accesso per visualizzare la dashboard principale e le analisi"
        },
        filter_by_user: {
          name: "Filtra Dashboard per Utente",
          description: "Capacità di filtrare i dati della dashboard per utenti specifici"
        }
      },
      // Dashboard IBE
      dashboard_ibe: {
        view: {
          name: "Visualizza Dashboard IBE",
          description: "Accesso per visualizzare la dashboard IBE"
        }
      },
      // Clienti
      clients: {
        view: {
          name: "Visualizza Clienti",
          description: "Visualizzare i dati dei clienti e la loro cronologia"
        },
        create: {
          name: "Crea Clienti",
          description: "Aggiungere nuovi clienti al sistema"
        },
        update: {
          name: "Aggiorna Clienti",
          description: "Modificare i dati esistenti dei clienti"
        },
        delete: {
          name: "Elimina Clienti",
          description: "Eliminare clienti dal sistema (operazione critica)"
        },
        filter_by_user: {
          name: "Filtra Clienti per Utente",
          description: "Filtrare clienti per utente assegnato"
        }
      },
      // Contratti
      deals: {
        view: {
          name: "Visualizza Contratti",
          description: "Vedere tutti i contratti e le opportunità di vendita"
        },
        create: {
          name: "Crea Contratti",
          description: "Creare nuovi contratti e opportunità"
        },
        update: {
          name: "Aggiorna Contratti",
          description: "Modificare contratti esistenti"
        },
        delete: {
          name: "Elimina Contratti",
          description: "Eliminare contratti (attenzione: può influire su commissioni)"
        },
        filter_by_user: {
          name: "Filtra Contratti per Utente",
          description: "Filtrare contratti per utente assegnato"
        },
        generate: {
          name: "Genera PDF Contratti",
          description: "Generare documenti PDF per i contratti"
        },
        hours_view: {
          name: "Visualizza Monte Ore",
          description: "Visualizzare informazioni sul monte ore dei contratti"
        },
        hours_update: {
          name: "Aggiorna Monte Ore",
          description: "Modificare impostazioni monte ore sui contratti"
        }
      },
      // Lead
      leads: {
        view: {
          name: "Visualizza Lead",
          description: "Visualizzare tutti i lead e le opportunità"
        },
        create: {
          name: "Crea Lead",
          description: "Creare nuovi lead"
        },
        update: {
          name: "Aggiorna Lead",
          description: "Modificare lead esistenti"
        },
        delete: {
          name: "Elimina Lead",
          description: "Eliminare lead dal sistema"
        },
        convert: {
          name: "Converti Lead",
          description: "Convertire lead in clienti o contratti"
        },
        filter_by_user: {
          name: "Filtra Lead per Utente",
          description: "Filtrare lead per utente assegnato"
        }
      },
      // Note Lead
      lead_notes: {
        view: {
          name: "Visualizza Note Lead",
          description: "Visualizzare le note sui lead"
        },
        create: {
          name: "Crea Note Lead",
          description: "Creare note sui lead"
        },
        update: {
          name: "Aggiorna Note Lead",
          description: "Modificare note lead esistenti"
        },
        delete: {
          name: "Elimina Note Lead",
          description: "Eliminare note lead"
        }
      },
      // Fonti Lead
      lead_sources: {
        view: {
          name: "Visualizza Fonti Lead",
          description: "Visualizzare le fonti di acquisizione lead"
        },
        create: {
          name: "Crea Fonti Lead",
          description: "Creare nuove fonti lead"
        },
        update: {
          name: "Aggiorna Fonti Lead",
          description: "Modificare fonti lead esistenti"
        },
        delete: {
          name: "Elimina Fonti Lead",
          description: "Eliminare fonti lead"
        },
        manage: {
          name: "Gestisci Fonti Lead",
          description: "Gestione completa delle fonti lead"
        }
      },
      // Calendario
      calendar: {
        view: {
          name: "Visualizza Calendario",
          description: "Accesso per visualizzare eventi del calendario"
        },
        create: {
          name: "Crea Eventi",
          description: "Creare nuovi eventi del calendario"
        },
        update: {
          name: "Aggiorna Eventi",
          description: "Modificare eventi del calendario esistenti"
        },
        delete: {
          name: "Elimina Eventi",
          description: "Eliminare eventi del calendario"
        }
      },
      // Progetti
      projects: {
        view: {
          name: "Visualizza Progetti",
          description: "Visualizzare informazioni e progresso dei progetti"
        },
        create: {
          name: "Crea Progetti",
          description: "Creare nuovi progetti"
        },
        update: {
          name: "Aggiorna Progetti",
          description: "Modificare progetti esistenti"
        },
        delete: {
          name: "Elimina Progetti",
          description: "Eliminare progetti dal sistema"
        }
      },
      // Task
      tasks: {
        view: {
          name: "Visualizza Task",
          description: "Visualizzare task e attività"
        },
        create: {
          name: "Crea Task",
          description: "Creare nuovi task"
        },
        update: {
          name: "Aggiorna Task",
          description: "Modificare task esistenti"
        },
        delete: {
          name: "Elimina Task",
          description: "Eliminare task"
        },
        complete: {
          name: "Completa Task",
          description: "Segnare i task come completati"
        },
        assign: {
          name: "Assegna Task",
          description: "Assegnare task agli utenti"
        },
        filter_by_user: {
          name: "Filtra Task per Utente",
          description: "Filtrare task per utente assegnato"
        }
      },
      // Ticket
      tickets: {
        view: {
          name: "Visualizza Ticket",
          description: "Visualizzare i ticket di supporto"
        },
        create: {
          name: "Crea Ticket",
          description: "Creare nuovi ticket di supporto"
        },
        update: {
          name: "Aggiorna Ticket",
          description: "Modificare ticket esistenti"
        },
        delete: {
          name: "Elimina Ticket",
          description: "Eliminare ticket"
        },
        assign: {
          name: "Assegna Ticket",
          description: "Assegnare ticket agli utenti"
        },
        generate: {
          name: "Esporta Ticket",
          description: "Esportare i dati dei ticket in CSV/Excel"
        }
      },
      // Tipi di Intervento
      ticket_types: {
        view: {
          name: "Visualizza Tipi Intervento",
          description: "Visualizzare le configurazioni dei tipi di intervento"
        },
        create: {
          name: "Crea Tipi Intervento",
          description: "Creare nuovi tipi di intervento"
        },
        update: {
          name: "Aggiorna Tipi Intervento",
          description: "Modificare tipi di intervento esistenti"
        },
        delete: {
          name: "Elimina Tipi Intervento",
          description: "Rimuovere tipi di intervento"
        },
        manage: {
          name: "Gestisci Tipi Intervento",
          description: "Gestione completa dei tipi di intervento"
        }
      },
      // Tracciamento Ore Ticket
      ticket_time_entries: {
        view: {
          name: "Visualizza Ore Lavorate",
          description: "Visualizzare le ore lavorate sui ticket"
        },
        create: {
          name: "Registra Ore",
          description: "Registrare ore di lavoro sui ticket"
        },
        update: {
          name: "Aggiorna Ore Lavorate",
          description: "Modificare le ore lavorate esistenti"
        },
        delete: {
          name: "Elimina Ore Lavorate",
          description: "Rimuovere registrazioni ore"
        },
        manage: {
          name: "Gestisci Ore Lavorate",
          description: "Gestione completa di tutte le ore lavorate"
        }
      },
      // Configurazioni SLA Ticket
      ticket_sla_configs: {
        view: {
          name: "Visualizza Configurazioni SLA",
          description: "Visualizzare le impostazioni di configurazione SLA"
        },
        create: {
          name: "Crea Configurazioni SLA",
          description: "Creare nuove configurazioni SLA"
        },
        update: {
          name: "Aggiorna Configurazioni SLA",
          description: "Modificare configurazioni SLA esistenti"
        },
        delete: {
          name: "Elimina Configurazioni SLA",
          description: "Rimuovere configurazioni SLA"
        },
        manage: {
          name: "Gestisci Configurazioni SLA",
          description: "Gestione completa delle impostazioni SLA"
        }
      },
      // WhatsApp
      whatsapp: {
        view: {
          name: "Visualizza WhatsApp",
          description: "Accedere alle conversazioni WhatsApp"
        },
        create: {
          name: "Invia Messaggi WhatsApp",
          description: "Inviare messaggi WhatsApp ai clienti"
        },
        assign: {
          name: "Visualizza Solo Chat WhatsApp Assegnate",
          description: "Vedere solo le chat WhatsApp dei clienti assegnati"
        },
        update: {
          name: "Gestisci Configurazioni WhatsApp",
          description: "Assegnare configurazioni WhatsApp agli utenti e gestire le impostazioni"
        }
      },
      // Fatture
      invoices: {
        view: {
          name: "Visualizza Fatture",
          description: "Accedere alle informazioni delle fatture"
        },
        create: {
          name: "Crea Fatture",
          description: "Generare nuove fatture"
        },
        update: {
          name: "Aggiorna Fatture",
          description: "Modificare fatture esistenti"
        },
        delete: {
          name: "Elimina Fatture",
          description: "Eliminare fatture dal sistema"
        }
      },
      // FattureInCloud
      fattureincloud: {
        view: {
          name: "Visualizza Dati Fatture in Cloud",
          description: "Accedere ai dati dell'integrazione Fatture in Cloud"
        },
        create: {
          name: "Crea Fatture in Cloud",
          description: "Creare fatture tramite Fatture in Cloud"
        },
        update: {
          name: "Aggiorna Impostazioni Fatture in Cloud",
          description: "Modificare la configurazione Fatture in Cloud"
        },
        delete: {
          name: "Elimina Dati Fatture in Cloud",
          description: "Rimuovere dati dall'integrazione Fatture in Cloud"
        },
        sync: {
          name: "Sincronizza Fatture in Cloud",
          description: "Sincronizzare i dati con Fatture in Cloud"
        },
        configure: {
          name: "Configura Fatture in Cloud",
          description: "Configurare le impostazioni dell'integrazione Fatture in Cloud"
        }
      },
      // Documenti
      documents: {
        view: {
          name: "Visualizza Documenti",
          description: "Accedere alla libreria documenti"
        },
        create: {
          name: "Carica Documenti",
          description: "Caricare nuovi documenti nel sistema"
        },
        update: {
          name: "Aggiorna Documenti",
          description: "Modificare documenti esistenti"
        },
        delete: {
          name: "Elimina Documenti",
          description: "Rimuovere documenti dal sistema"
        },
        manage: {
          name: "Gestisci Documenti",
          description: "Accesso completo alla gestione documenti"
        },
        filter_by_user: {
          name: "Filtra Documenti per Utente",
          description: "Filtrare documenti per proprietario"
        }
      },
      // Impostazioni
      settings: {
        view: {
          name: "Visualizza Impostazioni",
          description: "Accedere alle impostazioni del sistema"
        },
        update: {
          name: "Aggiorna Impostazioni",
          description: "Modificare la configurazione del sistema"
        },
        create: {
          name: "Importa/Esporta Dati",
          description: "Importare ed esportare dati del sistema"
        }
      },
      // Utenti
      users: {
        view: {
          name: "Visualizza Utenti",
          description: "Accedere alle informazioni degli utenti"
        },
        create: {
          name: "Crea Utenti",
          description: "Aggiungere nuovi utenti al sistema"
        },
        update: {
          name: "Aggiorna Utenti",
          description: "Modificare dati utenti esistenti"
        },
        delete: {
          name: "Elimina Utenti",
          description: "Rimuovere utenti dal sistema"
        }
      },
      // Ruoli
      roles: {
        view: {
          name: "Visualizza Ruoli",
          description: "Accedere alla configurazione dei ruoli"
        },
        create: {
          name: "Crea Ruoli",
          description: "Creare nuovi ruoli utente"
        },
        update: {
          name: "Aggiorna Ruoli",
          description: "Modificare ruoli esistenti"
        },
        delete: {
          name: "Elimina Ruoli",
          description: "Rimuovere ruoli dal sistema"
        }
      },
      // Servizi
      services: {
        view: {
          name: "Visualizza Servizi",
          description: "Accedere al catalogo servizi"
        },
        create: {
          name: "Crea Servizi",
          description: "Aggiungere nuovi servizi"
        },
        update: {
          name: "Aggiorna Servizi",
          description: "Modificare servizi esistenti"
        },
        delete: {
          name: "Elimina Servizi",
          description: "Rimuovere servizi"
        },
        manage: {
          name: "Gestisci Servizi",
          description: "Accesso completo alla gestione servizi"
        }
      },
      // Costi Servizi
      service_costs: {
        view: {
          name: "Visualizza Costi Servizi",
          description: "Visualizzare informazioni sui costi dei servizi"
        },
        create: {
          name: "Crea Costi Servizi",
          description: "Aggiungere nuovi costi servizi"
        },
        update: {
          name: "Aggiorna Costi Servizi",
          description: "Modificare costi servizi esistenti"
        },
        delete: {
          name: "Elimina Costi Servizi",
          description: "Rimuovere costi servizi"
        }
      },
      // Template Task Servizi
      service_task_templates: {
        view: {
          name: "Visualizza Template Task Servizi",
          description: "Visualizzare i template task dei servizi"
        },
        create: {
          name: "Crea Template Task Servizi",
          description: "Creare nuovi template task per i servizi"
        },
        update: {
          name: "Aggiorna Template Task Servizi",
          description: "Modificare template task servizi esistenti"
        },
        delete: {
          name: "Elimina Template Task Servizi",
          description: "Rimuovere template task servizi"
        },
        manage: {
          name: "Gestisci Template Task Servizi",
          description: "Gestione completa dei template task servizi"
        }
      },
      // Margini Servizi
      service_margins: {
        view: {
          name: "Visualizza Margini Servizi",
          description: "Visualizzare informazioni sui margini dei servizi"
        }
      },
      // Spese Clienti
      client_expenses: {
        view: {
          name: "Visualizza Spese Clienti",
          description: "Visualizzare informazioni sulle spese dei clienti"
        },
        create: {
          name: "Crea Spese Clienti",
          description: "Aggiungere nuove spese clienti"
        },
        update: {
          name: "Aggiorna Spese Clienti",
          description: "Modificare spese clienti esistenti"
        },
        delete: {
          name: "Elimina Spese Clienti",
          description: "Rimuovere spese clienti"
        },
        filter_by_user: {
          name: "Filtra Spese Clienti per Utente",
          description: "Filtrare spese clienti per utente"
        }
      },
      // Noleggi
      rentals: {
        view: {
          name: "Visualizza Noleggi",
          description: "Visualizzare informazioni sui noleggi"
        },
        create: {
          name: "Crea Noleggi",
          description: "Creare nuovi noleggi"
        },
        update: {
          name: "Aggiorna Noleggi",
          description: "Modificare noleggi esistenti"
        },
        delete: {
          name: "Elimina Noleggi",
          description: "Rimuovere noleggi"
        }
      },
      // Metodi di Pagamento
      payment_methods: {
        view: {
          name: "Visualizza Metodi di Pagamento",
          description: "Accedere alle impostazioni dei metodi di pagamento"
        },
        create: {
          name: "Crea Metodi di Pagamento",
          description: "Aggiungere nuovi metodi di pagamento"
        },
        update: {
          name: "Aggiorna Metodi di Pagamento",
          description: "Modificare metodi di pagamento"
        },
        delete: {
          name: "Elimina Metodi di Pagamento",
          description: "Rimuovere metodi di pagamento"
        }
      },
      // Configurazione API
      api_config: {
        view: {
          name: "Visualizza Configurazioni API",
          description: "Accedere alle impostazioni API"
        },
        create: {
          name: "Crea Configurazioni API",
          description: "Aggiungere nuove configurazioni API"
        },
        update: {
          name: "Aggiorna Configurazioni API",
          description: "Modificare impostazioni API"
        },
        delete: {
          name: "Elimina Configurazioni API",
          description: "Rimuovere configurazioni API"
        }
      },
      // Categorie
      categories: {
        view: {
          name: "Visualizza Categorie",
          description: "Accedere alla gestione categorie"
        },
        create: {
          name: "Crea Categorie",
          description: "Aggiungere nuove categorie"
        },
        update: {
          name: "Aggiorna Categorie",
          description: "Modificare categorie esistenti"
        },
        delete: {
          name: "Elimina Categorie",
          description: "Rimuovere categorie"
        }
      },
      // Inventario
      inventory: {
        view: {
          name: "Visualizza Inventario",
          description: "Accedere alle informazioni dell'inventario"
        },
        create: {
          name: "Crea Inventario",
          description: "Aggiungere nuovi articoli inventario"
        },
        update: {
          name: "Aggiorna Inventario",
          description: "Modificare articoli inventario"
        },
        delete: {
          name: "Elimina Inventario",
          description: "Rimuovere articoli inventario"
        },
        manage: {
          name: "Gestisci Inventario",
          description: "Accesso completo alla gestione inventario"
        }
      },
      // Commissioni
      commissions: {
        view: {
          name: "Visualizza Commissioni",
          description: "Accedere alle informazioni sulle commissioni"
        },
        update: {
          name: "Aggiorna Commissioni",
          description: "Modificare dati commissioni"
        },
        manage: {
          name: "Gestisci Commissioni",
          description: "Gestione completa commissioni (operazione finanziaria)"
        },
        refresh: {
          name: "Ricalcola Commissioni",
          description: "Ricalcolare i dati delle commissioni"
        }
      },
      // Commissioni Utenti
      user_commissions: {
        view: {
          name: "Visualizza Commissioni Utenti",
          description: "Visualizzare informazioni sulle commissioni degli utenti"
        },
        update: {
          name: "Aggiorna Commissioni Utenti",
          description: "Modificare dati commissioni utenti (operazione finanziaria critica)"
        },
        manage: {
          name: "Gestisci Commissioni Utenti",
          description: "Gestione completa commissioni utenti"
        }
      },
      // Gruppi Commissioni
      commission_groups: {
        view: {
          name: "Visualizza Gruppi Commissioni",
          description: "Visualizzare informazioni sui gruppi commissioni"
        },
        create: {
          name: "Crea Gruppi Commissioni",
          description: "Creare nuovi gruppi commissioni"
        },
        update: {
          name: "Aggiorna Gruppi Commissioni",
          description: "Modificare gruppi commissioni esistenti"
        },
        delete: {
          name: "Elimina Gruppi Commissioni",
          description: "Rimuovere gruppi commissioni"
        }
      },
      // Report Commissioni
      commission_reports: {
        view: {
          name: "Visualizza Report Commissioni",
          description: "Visualizzare report e analisi commissioni"
        }
      },
      // Commissioni Avanzate
      commission_advanced: {
        manage: {
          name: "Gestisci Commissioni Avanzate",
          description: "Accesso alle impostazioni commissioni avanzate"
        }
      },
      // Partner Esterni
      external_partners: {
        view: {
          name: "Visualizza Partner Esterni",
          description: "Visualizzare informazioni sui partner esterni"
        },
        create: {
          name: "Crea Partner Esterni",
          description: "Aggiungere nuovi partner esterni"
        },
        update: {
          name: "Aggiorna Partner Esterni",
          description: "Modificare partner esterni esistenti"
        },
        delete: {
          name: "Elimina Partner Esterni",
          description: "Rimuovere partner esterni"
        }
      },
      // Task Partner
      partner_tasks: {
        view: {
          name: "Visualizza Task Partner",
          description: "Visualizzare informazioni sui task dei partner"
        },
        create: {
          name: "Crea Task Partner",
          description: "Creare nuovi task per i partner"
        },
        update: {
          name: "Aggiorna Task Partner",
          description: "Modificare task partner esistenti"
        },
        delete: {
          name: "Elimina Task Partner",
          description: "Rimuovere task partner"
        },
        assign: {
          name: "Assegna Task Partner",
          description: "Assegnare task ai partner"
        },
        manage: {
          name: "Gestisci Task Partner",
          description: "Gestione completa task partner"
        }
      },
      // Segnalatori
      referrers: {
        view: {
          name: "Visualizza Segnalatori",
          description: "Visualizzare informazioni sui segnalatori"
        },
        create: {
          name: "Crea Segnalatori",
          description: "Aggiungere nuovi segnalatori"
        },
        update: {
          name: "Aggiorna Segnalatori",
          description: "Modificare segnalatori esistenti"
        },
        delete: {
          name: "Elimina Segnalatori",
          description: "Rimuovere segnalatori"
        }
      },
      // Analisi
      analytics: {
        view: {
          name: "Visualizza Analisi",
          description: "Accedere alle analisi e business intelligence"
        },
        refresh: {
          name: "Aggiorna Analisi",
          description: "Aggiornare i dati analitici"
        }
      },
      // Report
      reports: {
        view: {
          name: "Visualizza Report",
          description: "Accedere ai report di sistema"
        },
        create: {
          name: "Crea Report",
          description: "Generare nuovi report"
        },
        update: {
          name: "Aggiorna Report",
          description: "Modificare report esistenti"
        },
        delete: {
          name: "Elimina Report",
          description: "Rimuovere report"
        },
        export: {
          name: "Esporta Report",
          description: "Esportare dati dei report"
        }
      },
      // Template
      templates: {
        view: {
          name: "Visualizza Template",
          description: "Accedere ai template documenti"
        },
        create: {
          name: "Crea Template",
          description: "Creare nuovi template documenti"
        },
        update: {
          name: "Aggiorna Template",
          description: "Modificare template esistenti"
        },
        delete: {
          name: "Elimina Template",
          description: "Rimuovere template documenti"
        }
      },
      // Firme
      signatures: {
        view: {
          name: "Visualizza Firme",
          description: "Accedere alle firme documenti"
        },
        create: {
          name: "Crea Firme",
          description: "Creare nuove firme per documenti"
        }
      },
      // Firma Email
      email_signature: {
        generate: {
          name: "Genera Firma Email",
          description: "Generare firme email personalizzate"
        }
      },
      // Newsletter
      newsletter: {
        view: {
          name: "Visualizza Newsletter",
          description: "Accedere al sistema di gestione newsletter"
        },
        create: {
          name: "Crea Newsletter",
          description: "Creare nuove liste e campagne newsletter"
        },
        update: {
          name: "Aggiorna Newsletter",
          description: "Modificare liste e campagne newsletter esistenti"
        },
        delete: {
          name: "Elimina Newsletter",
          description: "Rimuovere liste e campagne newsletter"
        },
        send: {
          name: "Invia Newsletter",
          description: "Inviare campagne newsletter agli iscritti"
        }
      },
      // Prenotazioni
      booking: {
        view: {
          name: "Visualizza Prenotazioni",
          description: "Visualizzare le prenotazioni e i loro dettagli"
        },
        create: {
          name: "Crea Prenotazioni",
          description: "Creare nuove prenotazioni"
        },
        update: {
          name: "Modifica Prenotazioni",
          description: "Modificare prenotazioni esistenti (conferma, riprogramma, ecc.)"
        },
        delete: {
          name: "Elimina Prenotazioni",
          description: "Cancellare o eliminare prenotazioni"
        },
        manage: {
          name: "Gestisci Prenotazioni",
          description: "Gestione completa prenotazioni (tipi evento, disponibilità)"
        },
        filter_by_user: {
          name: "Filtra Prenotazioni per Utente",
          description: "Visualizzare solo le prenotazioni assegnate all'utente corrente"
        }
      },
      // Impostazioni Prenotazioni
      settings_booking: {
        view: {
          name: "Visualizza Impostazioni Prenotazioni",
          description: "Visualizzare la configurazione delle prenotazioni"
        },
        manage: {
          name: "Gestisci Impostazioni Prenotazioni",
          description: "Modificare impostazioni prenotazioni (branding, notifiche, ecc.)"
        }
      },
      // Impostazioni SendGrid
      settings_sendgrid: {
        view: {
          name: "Visualizza Domini SendGrid",
          description: "Visualizzare la configurazione dei domini SendGrid"
        },
        create: {
          name: "Crea Domini SendGrid",
          description: "Aggiungere nuovi domini SendGrid"
        },
        update: {
          name: "Aggiorna Domini SendGrid",
          description: "Modificare impostazioni domini SendGrid"
        },
        delete: {
          name: "Elimina Domini SendGrid",
          description: "Rimuovere domini SendGrid"
        },
        verify: {
          name: "Verifica Domini SendGrid",
          description: "Verificare domini SendGrid tramite DNS"
        }
      },
      // Campi Personalizzati
      custom_fields: {
        manage: {
          name: "Gestisci Campi Personalizzati",
          description: "Creare e gestire campi personalizzati"
        }
      },
      // Query Personalizzate
      custom_queries: {
        view: {
          name: "Visualizza Query Personalizzate",
          description: "Visualizzare query database personalizzate"
        },
        create: {
          name: "Crea Query Personalizzate",
          description: "Creare nuove query personalizzate"
        }
      }
    }
  }
};
